<div class="componente-importantes text-start p-5 mt-3" style="min-height:700px;">
    <section class="">
    <form   class="row d-flex align-items-end"
          action=""
          method="post"
          (submit)="formSubmit()"
          [formGroup]="Step2form"
 
        >
            <div class="col">
                <label for="formControlInput" class="form-label">Etapa</label>
                <select required class="custom-outline-input form-select" formControlName="stages_id" aria-label="Default select">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listStage" [value]="item.id"> {{item.name}}</option>
                    </select>

            </div>
            <div class="col">
                <label for="formControlInput" class="form-label">Estado</label>
                <select required class="custom-outline-input form-select" formControlName="state" placeholder="Seleccione">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listStado" [value]="item.id"> {{item.name}}</option>
                    </select>

            </div>
            <div class="col">
                <label for="formControlInput" class="form-label">Fecha inicio</label>
                <input required="" type="date" class="date custom-outline-input form-control" formControlName="start_date" id="start_date">
            </div>
            <div class="col">
                <label for="formControlInput" class="form-label">Fecha termino</label>
                <input required="" type="date" class="date custom-outline-input form-control" formControlName="end_date" id="end_date">

            </div>
            <div class="col d-flex align-items-end ">
                <button [disabled]="!Step2form.valid" class="btn btn-outline-light form-control"> <i class="fa-solid fa-floppy-disk m-1" aria-hidden="true"></i> Añadir</button>
            </div>
    </form>
    </section>
        <section class="row">
            <div class="backgroundTable row mx-2 mt-5 pb-5">
                <table datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions"  class="componente-importantes" style="min-height:300px !important;">
                    <ng-container *ngIf="listaEtapas.length == 0">
                                            <div class="text-center text-white">
                                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                            </div>
                    </ng-container>
                    <ng-container *ngIf="listaEtapas.length != 0">
                    <thead>
                        <tr class="table-info">
                            <th class="text-white text-center">nombre</th>
                            <th class="text-white text-center">inicio</th>
                            <th class="text-white text-center">término</th>
                            <th class="text-white text-center">inicio real</th>
                            <th class="text-white text-center">estado</th>
                            <th class="text-white text-center">opciones</th>
                        </tr>
                    </thead>
                    <tbody>
            <tr *ngFor="let item of listaEtapas">

              <td class="text-center" >{{item.name}}</td>
              <td class="text-center"> {{item.start_date}} </td>
              <td class="text-center">{{item.end_date}}</td>
              <td class="text-center">
                {{item.real_end_date}}
              </td>
              <td class="text-center">{{item.state}}</td>
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="stageDelete(item.id)" >Eliminar</button>
                  </div>
                </div>
              </td>
   
            </tbody>
            </ng-container>
                </table>
            </div>
        </section>
    </div>